module.exports = __webpack_public_path__ + "img/emotion-ethical.545bb03.jpg";